import NextImage from 'next/image'

import { Button } from '@wartek-id/button-v1'
import { Dialog, DialogOverlay, DialogContent } from '@wartek-id/dialog-v1'
import type { DialogProps } from '@wartek-id/dialog-v1'
import { Text } from '@wartek-id/text-v1'

type SubmitDialogProps = Omit<DialogProps, 'children'> & {
  onCancel?: () => void
  onConfirm?: () => void
  isLoading?: boolean
}

export function SubmitConfirmationDialog({
  onCancel,
  onConfirm,
  isLoading,
  ...dialogProps
}: SubmitDialogProps) {
  return (
    <Dialog size="sm" {...dialogProps}>
      <DialogOverlay />
      <DialogContent
        aria-labelledby="confirmation-dialog-title"
        aria-describedby="confirmation-dialog-description"
      >
        <div className="p-6 space-y-4">
          <NextImage
            src={'/illustrations/img-publish-data.png'}
            alt=""
            height={84}
            width={84}
          />

          <div className="space-y-1">
            <Text variant="display-sm" as="h2" id="confirmation-dialog-title">
              Konfirmasi untuk Kirim Perencanaan
            </Text>
            <Text
              color="subdued"
              variant="body-lg"
              id="confirmation-dialog-description"
            >
              Perencanaan tidak dapat diubah lagi dan akan otomatis disetujui
              oleh Pejabat Penilai Kinerja.
            </Text>
          </div>
          <div className="flex space-x-5">
            <Button
              onClick={onCancel}
              color="white"
              size="lg"
              disabled={isLoading}
            >
              Kembali
            </Button>
            <Button
              onClick={onConfirm}
              color="blue"
              size="lg"
              isLoading={isLoading}
              disabled={isLoading}
            >
              Konfirmasi
            </Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  )
}
